module.exports = __webpack_public_path__ + "img/search-appbar.e954ecc5.png";